import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Ripple } from "primereact/ripple";
import { Nullable } from "primereact/ts-helpers";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Tooltip } from "primereact/tooltip";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from "primereact/confirmdialog";
import { InputNumberChangeEvent } from "primereact/inputnumber";
import { Image } from "primereact/image";
import NoDataCreated from "../../../Components/NoDataCreated";
import ErrorPage from "../../../Components/ErrorPage";
import { goToTop } from "../../../Components/goToTop";
import PageLoader from "../../../Components/PageLoader";
import { baseURL } from "../../../Api/ApiConstant";
import { formatDate, parseStringToDate } from "../../../Utils/getDate";
import NumberInput from "../../../Components/NumberInput";
import TextInput from "../../../Components/TextInput";
import FileInput from "../../../Components/FileInput";
import DatePicker from "../../../Components/DatePicker";
import DocumentViewModal from "../../../Components/DocumentViewModal";
import { getAppCurrencyType } from "../../../Utils/Common";

import {
  addProjctSpendingShop,
  addQuotationsDetails,
  projectSpendingDetalsDelete,
  updateQuotationsDetails,
} from "../../../Api/HeyTraderService/ProjectSpendingService";
import { useAppDispatch, useAppSelector } from "../../../Controllers/hooks";
import {
  getAllSpendingProjectList,
  getAllSpendingShopList,
} from "../../../Controllers/Thunks/HeyTraderThunks";
import {
  checkFileOthers,
  checkModelSelected,
  checkNumber,
  checkText,
} from "../../../Utils/Validator";
import { ProjectSpendingTypes } from "../../../Controllers/Types/HeyTraderTypes/ProjectSpending/ProjectSpendingTypes";
import { ProjectSpendingDataType } from "../../../Controllers/Types/HeyTraderTypes/ProjectSpending/ProjectSpendingDataType";
import { PojectSpendingShopType } from "../../../Controllers/Types/HeyTraderTypes/ProjectSpending/PojectSpendingShopType";
import { useSelector } from "react-redux";
import { RootState } from "../../../Controllers/Store";
import { hasPermission } from "../../../Controllers/Selectors/permissionsSelector";

const ProjectSpendingQuotation: React.FC = () => {
  const today = new Date();
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useRef<Toast>(null);
  const currencySymbol = getAppCurrencyType();

  const loadingPage = "";
  const error = "";
  const [loading, setLoading] = useState<boolean>(false);
  const [dataState, setDataState] = useState<"Add" | "Edit">("Add");
  const [customCreateLoading, setCustomCreateLoading] = useState<boolean>(false);
  const [documentFileUrl, setDocumentFileUrl] = useState<string>("");
  const [showDocViewModal, setShowDocViewModal] = useState<boolean>(false);
  const [owanProject, setOwanProject] = useState<boolean>(false);
  const [projectDetail, setProjectDetail] = useState<ProjectSpendingTypes | null>(null);
  const [quotationData, setQuotationData] = useState<ProjectSpendingDataType[]>([]);
  const [filteredQuotationData, setFilteredQuotationData] = useState<ProjectSpendingDataType[]>([]);
  const [selectedQuotationData, setSelectedQuotationData] = useState<ProjectSpendingDataType | null>(null);
  const [showQuotationModal, setShowQuotationModal] = useState<boolean>(false);
  const [quotationSearchKey, setQuotationSearchKey] = useState<string>("");
  const [quotationSubtotal, setQuotationSubtotal] = useState<number>(0);

  const [shopsData, setShopsData] = useState<PojectSpendingShopType[]>([]);
  const [filteredShopsData, setFilteredShopsData] = useState<PojectSpendingShopType[]>([]);
  const [showShopsModal, setShowShopsModal] = useState<boolean>(false);
  const [shopSearchKey, setShopSearchKey] = useState<string>("");
  const [customShopName, setCustomShopName] = useState<string>("");
  const [customShopNameError, setCustomShopNameError] = useState<string>("");

  const [quotationDate, setQuotationDate] = useState<Nullable<Date>>(today);
  const [selectedShop, setSelectedShop] = useState<PojectSpendingShopType | null>(null);
  const [quotationTitle, setQuotationTitle] = useState<string>("");
  const [quotationAmount, setQuotationAmount] = useState<number | null>(null);
  const [quotationFile, setQuotationFile] = useState<File | null>(null);
  const [quotationFileName, setQuotationFileName] = useState<string>("");

  const [quotationDateError, setQuotationDateError] = useState<string>("");
  const [quotationShopError, setQuotationShopError] = useState<string>("");
  const [quotationTitleError, setQuotationTitleError] = useState<string>("");
  const [quotationAmountError, setQuotationAmountError] = useState<string>("");
  const [quotationFileError, setQuotationFileError] = useState<string>("");

  const [navigateFrom, setNavigateFrom] = useState<string | null>(null);
  const [updateHasChanges, setUpdateHasChanges] = useState<boolean>(false);

  /* ******************************* Quotation ********************************* */

  // PERMISION HANDLER
  const useCanEdit = (screen: string, permission: string) => {
    return useSelector((state: RootState) =>
      hasPermission(state, screen, permission)
    );
  };

  const edit_data_quotation = useCanEdit("Project Spending", "eidt_quotations");
  const delete_data_quotation = useCanEdit(
    "Project Spending",
    "delete_quotations"
  );

  useEffect(() => {
    if (location.state) {
      if (location.state.projectDetail) {
        setProjectDetail(location.state.projectDetail as ProjectSpendingTypes);
      } else {
        setProjectDetail(null);
      }

      if (location?.state?.navigateFrom) {
        setNavigateFrom(location?.state?.navigateFrom)
      } else {
        setNavigateFrom(null);
      }
    }
  }, [location.state]);

  // my action for fetch project by state list
  const ProjectsListFromStore = useAppSelector(
    (state) => state.projectSpending.spendingProjectList
  );

  // for fetching data fro api tigger with state object actions
  useEffect(() => {
    if (ProjectsListFromStore.length === 0) {
      dispatch(getAllSpendingProjectList());
    }
  }, [ProjectsListFromStore?.length]);


  // find project from globle object list.
  useEffect(() => {
    const globleproject = location.state.projectDetail as ProjectSpendingTypes;

    setOwanProject(globleproject?.is_own_project);

    const projectfromState = ProjectsListFromStore.filter(
      (e) => e.project_id === globleproject.project_id
    );

    if (projectfromState.length > 0) {
      setProjectDetail(projectfromState[0]);

      setQuotationData(
        projectfromState[0].quotation as ProjectSpendingDataType[]
      );
    }
  }, [location.state, ProjectsListFromStore]);

  useEffect(() => {
    if (quotationData && quotationData?.length > 0) {
      const filteredData = quotationData?.filter((quotaion) =>
        quotaion
          ?.title!.toLowerCase()
          .includes(quotationSearchKey.toLowerCase())
      );
      setFilteredQuotationData(filteredData);
    }
  }, [quotationData, quotationSearchKey]);

  useEffect(() => {
    if (filteredQuotationData && filteredQuotationData?.length > 0) {
      setQuotationSubtotal(
        filteredQuotationData.reduce((acc, curr) => acc + (curr.amount || 0), 0)
      );
    } else {
      setQuotationSubtotal(0);
    }
  }, [filteredQuotationData]);

  const handleCloseQuotationModal = () => {
    setShowQuotationModal(false);

    handleResetQuotationFormFields();
    handleResetQuotationErrors();
  };

  const handleResetQuotationFormFields = () => {
    setQuotationDate(today);
    setSelectedShop(null);
    setQuotationTitle("");
    setQuotationAmount(null);
    setQuotationFile(null);
    setQuotationFileName("");
  };

  const handleResetQuotationErrors = () => {
    setQuotationDateError("");
    setQuotationShopError("");
    setQuotationTitleError("");
    setQuotationAmountError("");
    setQuotationFileError("");
  };

  const handleAddQuotation = () => {
    setShowQuotationModal(true);
    setDataState("Add");
  };

  // validation text handler for mpurchase
  useEffect(() => {
    checkModelSelected(selectedShop != null, false, setQuotationShopError);
  }, [selectedShop]);

  useEffect(() => {
    checkText(quotationTitle, false, setQuotationTitleError);
  }, [quotationTitle]);

  useEffect(() => {
    checkNumber(quotationAmount!, false, setQuotationAmountError);
  }, [quotationAmount]);

  // validations
  function checkCredentials(): boolean {
    const isDate = checkText(formatDate(quotationDate!), true, setQuotationDateError);
    const isShop = checkModelSelected(selectedShop != null, true, setQuotationShopError);
    const isQuotationTitle = checkText(quotationTitle, true, setQuotationTitleError);
    const isQuotationAmount = checkNumber(quotationAmount!, true, setQuotationAmountError);
    const isQuotationFile = checkFileOthers(quotationFile!, false, setQuotationFileError);

    return (
      isDate &&
      isShop &&
      isQuotationTitle &&
      isQuotationAmount &&
      isQuotationFile
    );
  }

  function showAPIErrors(keyName: string, error: string): void {
    if (keyName === "date") {
      setQuotationDateError(error);
    }
    if (keyName === "shop_id") {
      setQuotationShopError(error);
    }
    if (keyName === "title") {
      setQuotationTitleError(error);
    }
    if (keyName === "amount") {
      setQuotationAmountError(error);
    }
    if (keyName === "file") {
      setQuotationFileError(error);
    }
  }

  const handleCreateQuotation = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentials()) {
      setLoading(true);

      const data = await addQuotationsDetails(
        projectDetail?.project_id!,
        formatDate(quotationDate!),
        selectedShop?.id!,
        quotationTitle,
        quotationAmount!,
        quotationFile!
      );

      if (data.statusCode === 200) {
        // call shop dispach event
        dispatch(getAllSpendingProjectList());

        setLoading(false);
        handleCloseQuotationModal();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Quotation created successfully.",
            life: 3000,
          });
        }
      } else if (data.statusCode === 422) {
        setLoading(false);
        Object.entries(data.errors ?? []).map(([key, value]) => (
          showAPIErrors(key, value[0])
        ))
      } else {
        setLoading(false);
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error creating the quotation.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleEditQuotation = (data: ProjectSpendingDataType) => {
    if (data) {
      setSelectedQuotationData(data);
      setShowQuotationModal(true);
      setDataState("Edit");

      setQuotationDate(parseStringToDate(data?.date!) || null);
      setSelectedShop(data?.spending_shop || null);
      setQuotationTitle(data?.title || "");
      setQuotationAmount(data?.amount || null);
    } else {
      setSelectedQuotationData(null);
      setQuotationDate(null);
      setSelectedShop(null);
      setQuotationTitle("");
      setQuotationAmount(null);
    }
  };

  const handleUpdateQuotation = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentials()) {
      setLoading(true);

      const data = await updateQuotationsDetails(
        projectDetail?.project_id!,
        formatDate(quotationDate!),
        selectedShop?.id!,
        quotationTitle,
        quotationAmount!,
        quotationFile!,
        selectedQuotationData?.id!
      );

      if (data.statusCode === 200) {
        // call shop dispach event
        dispatch(getAllSpendingProjectList());
        setTimeout(() => {
          setLoading(false);
          handleCloseQuotationModal();

          if (toast.current) {
            toast.current.show({
              severity: "success",
              summary: "Success",
              detail: "Quotation updated successfully.",
              life: 3000,
            });
          }
        }, 500);
      } else if (data.statusCode === 422) {
        setLoading(false);
        Object.entries(data.errors ?? []).map(([key, value]) => (
          showAPIErrors(key, value[0])
        ))
      } else {
        setLoading(false);
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error updating the quotation.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleDeleteQuotation = (data: ProjectSpendingDataType) => {
    const quotationId = data?.id;

    confirmDialog({
      message: "Are you sure you want to delete this quotation?",
      header: "Confirm the deletion",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      accept: () => deleteQuotation(quotationId!),
      dismissableMask: true,
      resizable: false,
      draggable: false,
    });
  };

  const deleteQuotation = async (quotationId: number) => {
    const result = await projectSpendingDetalsDelete(quotationId);

    if (result.statusCode === 200) {
      dispatch(getAllSpendingProjectList());

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Record deleted successfully.",
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error deleting the record.",
          life: 3000,
        });
      }
    }
  };

  const quotationModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">{dataState} quotation</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseQuotationModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const quotationModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseQuotationModal}
      />

      <Button
        label={`${loading ? "Processing" : dataState === "Add" ? "Save" : "Update"}`}
        onClick={dataState === "Add" ? handleCreateQuotation : handleUpdateQuotation}
        loading={loading}
        className="custom_btn primary"
        disabled={dataState === 'Edit' && !updateHasChanges}
      />
    </div>
  );

  const handleQuotationFileUpload = (file: File) => {
    setQuotationFile(file);
    setQuotationFileName(file.name);
  };

  const handleClearQuotationFile = () => {
    setQuotationFile(null);
    setQuotationFileName("");
  };

  const handleQuotationAmountChange = (e: InputNumberChangeEvent) => {
    if (e.value != null) {
      setQuotationAmount(e.value);
    } else {
      setQuotationAmount(null);
    }
  };

  const handleCloseDocViewModal = () => {
    setShowDocViewModal(false);
    setDocumentFileUrl("");
  };

  const handleViewDocumentFile = (fileUrl: string) => {
    if (fileUrl && fileUrl !== "") {
      setShowDocViewModal(true);
      setDocumentFileUrl(baseURL + fileUrl);
    } else {
      setShowDocViewModal(false);
      setDocumentFileUrl("");
    }
  };

  const quotationFileBody = (rowData: ProjectSpendingDataType) => {
    const data = rowData;
    const file = data?.file;
    const fileExt = data?.file_extension;

    return (
      <div className="table_file_view_area">
        {file && file !== null ? (
          <React.Fragment>
            {fileExt === "pdf" ? (
              <div
                className="item_file_container"
                onClick={() => handleViewDocumentFile(file!)}
              >
                <i className="bi bi-file-earmark-pdf doc_icon"></i>
              </div>
            ) : (
              <div className="note_image_container">
                <Image src={baseURL + file} className="note_img" preview />
              </div>
            )}
          </React.Fragment>
        ) : (
          <span className="no_image_text">---</span>
        )}
      </div>
    );
  };

  const quotationTableActionBody = (rowData: ProjectSpendingDataType) => {
    const data = rowData;
    return (
      <React.Fragment>
        <Tooltip target=".data_action_btn" />

        <div className="tabel_btn_area custom mt-1 mb-1">
          {edit_data_quotation && (owanProject ||projectDetail?.can_edit===true ) && (
            <button
              className="data_action_btn with_bg primary_table_btn p-ripple"
              onClick={() => handleEditQuotation(data)}
              data-pr-tooltip={`Edit`}
              data-pr-position="top"
            >
              <i className="bi bi-pencil-square"></i>
              <Ripple />
            </button>
          )}

          {delete_data_quotation && (owanProject ||projectDetail?.can_edit===true ) && (
            <button
              className="data_action_btn with_bg danger_table_btn p-ripple"
              onClick={() => handleDeleteQuotation(data)}
              data-pr-tooltip={`Delete`}
              data-pr-position="top"
            >
              <i className="bi bi-trash3"></i>
              <Ripple />
            </button>
          )}
        </div>
      </React.Fragment>
    );
  };

  /* Shops */

  // for the resons
  const dispatch = useAppDispatch();

  // for fetching data fro api tigger with state object actions
  useEffect(() => {
    dispatch(getAllSpendingShopList());
  }, [dispatch]);

  // this is get data from state list and set projectlist
  const shopList = useAppSelector(
    (state) => state.projctSpendingShops.shopList
  );

  /* Shops */
  useEffect(() => {
    const fetchShopsData = async () => {
      const activeShops = shopList?.filter((shop) => shop?.status === 1);
      setShopsData(activeShops);
    };

    fetchShopsData();
  }, [shopList]);

  useEffect(() => {
    if (shopsData && shopsData?.length > 0) {
      const filteredShops = shopsData.filter((shop) =>
        shop?.shop_name!.toLowerCase().includes(shopSearchKey.toLowerCase())
      );
      setFilteredShopsData(filteredShops);
    } else {
      setFilteredShopsData([]);
    }
  }, [shopsData, shopSearchKey]);

  const handleCloseShopsModal = () => {
    setShowShopsModal(false);
    setShopSearchKey("");

    handleClearCustomShopFields();
  };

  const handleClearCustomShopFields = () => {
    setCustomShopName("");
    setCustomShopNameError("");
  };

  const handleAddShop = () => {
    setShowShopsModal(true);
  };

  const handleSelectShop = (shop: PojectSpendingShopType) => {
    setSelectedShop(shop);

    setTimeout(() => {
      handleCloseShopsModal();
    }, 200);
  };

  const handleCreateCustomShop = async (e: React.FormEvent) => {
    e.preventDefault();

    if (customShopName !== "") {
      setCustomCreateLoading(true);

      const data = await addProjctSpendingShop(customShopName);

      if (data.statusCode === 200) {
        // call shop dispach event
        dispatch(getAllSpendingShopList());

        setCustomCreateLoading(false);
        handleClearCustomShopFields();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Shop added successfully.",
            life: 3000,
          });
        }
      } else {
        setCustomCreateLoading(false);
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error adding the shop.",
            life: 3000,
          });
        }
      }
    }
  };
  /* *************************************************************************** */

  useEffect(() => {
    const handleQuotationDetailsChange = () => {
      if (formatDate(quotationDate!) !== selectedQuotationData?.date) {
        setUpdateHasChanges(true);
      } else if (quotationTitle !== selectedQuotationData?.title) {
        setUpdateHasChanges(true);
      } else if (selectedShop?.id !== selectedQuotationData?.shop_id) {
        setUpdateHasChanges(true);
      } else if (quotationAmount !== selectedQuotationData?.amount) {
        setUpdateHasChanges(true);
      } else if (dataState === 'Edit' && (quotationFile !== null && quotationFileName !== '')) {
        setUpdateHasChanges(true);
      } else {
        setUpdateHasChanges(false);
      }
    }

    handleQuotationDetailsChange();
  }, [
    quotationDate,
    quotationTitle,
    selectedShop,
    quotationAmount,
    quotationFile,
    quotationFileName,
    dataState,
    selectedQuotationData
  ]);

  /* **************************** Common functions ***************************** */
  const goBack = () => {
    navigate(-1);
    goToTop();
  };
  /* *************************************************************************** */

  return (
    <React.Fragment>
      <Toast ref={toast} />

      <div className="main_content layout_padding show_side_bar">
        {loadingPage ? (
          <PageLoader />
        ) : error ? (
          <ErrorPage errorMessage={error} />
        ) : (
          <div className="page_content mt-0">
            <div className="page_breadcrumb_area">
              {navigateFrom && navigateFrom === 'Project' ? (
                <ul className="page_breadcrumb">
                  <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-2)}>
                    {projectDetail?.job_number + ": " + projectDetail?.address!}
                  </li>
                  <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                    Project spending
                  </li>
                  <li className="page_breadcrumb_item active">
                    Quotation
                  </li>
                </ul>
              ) : (
                <ul className="page_breadcrumb">
                  <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-2)}>
                    Projects
                  </li>
                  <li className="page_breadcrumb_item has_child">
                    {projectDetail?.job_number + ": " + projectDetail?.address!}
                  </li>
                  <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                    Project spending
                  </li>
                  <li className="page_breadcrumb_item active">Quotation</li>
                </ul>
              )}

              <button className="back_btn p-ripple" onClick={goBack}>
                <i className="bi bi-arrow-left me-2"></i>
                Back
                <Ripple />
              </button>
            </div>

            <div className="page_header_area custom mt-sm-3 mt-3">
              <div className="display_label_area">
                <div className="display_label">
                  <span className="display_label_text">Subtotal :&nbsp;</span>
                  <span>
                    {currencySymbol}&nbsp;
                    {quotationSubtotal.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </span>
                </div>
              </div>
              <div className="page_action_area">
                <div className="filter_input_group">
                  <IconField iconPosition="right">
                    {quotationSearchKey === "" ? (
                      <InputIcon className="bi bi-search"></InputIcon>
                    ) : (
                      <InputIcon
                        className="bi bi-x-lg search_clear_icon"
                        onClick={() => setQuotationSearchKey("")}
                      ></InputIcon>
                    )}

                    <InputText
                      id="quotationSearchKey"
                      value={quotationSearchKey}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setQuotationSearchKey(e.target.value)}
                      className="custom_form_input filter_input"
                      placeholder="Search by title"
                      type="search"
                    />
                  </IconField>
                </div>

              {((owanProject ||projectDetail?.can_edit===true )) && (<button
                  className="add_data_link_btn p-ripple"
                  onClick={handleAddQuotation}
                >
                  <i className="bi bi-plus-circle"></i>
                  <span>Add quotation</span>
                  <Ripple />
                </button>)}  
              </div>
            </div>

            <div className="page_main_content_section p-0">
              {quotationData && quotationData?.length > 0 ? (
                <DataTable
                  value={filteredQuotationData}
                  paginator
                  size="small"
                  rows={10}
                  emptyMessage="No records found!"
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  tableStyle={{ minWidth: "50rem" }}
                  paginatorDropdownAppendTo={"self"}
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                  className="page_table p-0 p-sm-2"
                  rowHover
                  scrollable
                >
                  <Column
                    header="No."
                    headerClassName="text_purple"
                    className="text_bold"
                    body={(rowData: ProjectSpendingDataType, { rowIndex }) => (
                      <span>{rowIndex + 1}.</span>
                    )}
                    style={{ width: "8%" }}
                  ></Column>

                  <Column
                    header="Date"
                    headerClassName="text_purple"
                    field="date"
                    body={(rowData: ProjectSpendingDataType) => (
                      <span className="text_no_wrap">
                        {rowData?.date ? rowData?.date : "---"}
                      </span>
                    )}
                    style={{ width: "12%" }}
                  ></Column>

                  <Column
                    header="Shop"
                    headerClassName="text_purple"
                    field="spending_shop.shop_name"
                    body={(rowData: ProjectSpendingDataType) => (
                      <span className="text_nowrap text-capitalize">
                        {rowData?.spending_shop && rowData?.spending_shop?.shop_name ? rowData?.spending_shop?.shop_name : "---"}
                      </span>
                    )}
                    style={{ width: "15%" }}
                  ></Column>

                  <Column
                    header="Title"
                    headerClassName="text_purple title_column"
                    field="title"
                    body={(rowData: ProjectSpendingDataType) => (
                      <span className="text-capitalize">
                        {rowData?.title ? rowData?.title : "---"}
                      </span>
                    )}
                    style={{ width: "20%" }}
                  ></Column>

                  <Column
                    header="Amount"
                    headerClassName="text_purple"
                    alignHeader={"right"}
                    field="amount"
                    className="text_bold"
                    body={(rowData: ProjectSpendingDataType) => (
                      <span className="text_no_wrap flex_end">
                        {currencySymbol}&nbsp;
                        {rowData?.amount ? rowData?.amount.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "---"}
                      </span>
                    )}
                    style={{ width: "20%" }}
                  ></Column>

                  <Column
                    header="File"
                    headerClassName="text_purple"
                    alignHeader={"center"}
                    field="file"
                    body={quotationFileBody}
                    style={{ width: "12%" }}
                  ></Column>

                  <Column
                    alignHeader="center"
                    body={quotationTableActionBody}
                    frozen
                    alignFrozen="right"
                  ></Column>
                </DataTable>
              ) : (
                <NoDataCreated
                  message={`No quotation data added. To add, click on Add button.`}
                />
              )}
            </div>
          </div>
        )}
      </div>

      {/* Quotation modal */}
      <Dialog
        visible={showQuotationModal}
        headerClassName="custom_modal_header"
        header={quotationModalHeader}
        footer={quotationModalFooter}
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseQuotationModal}
      >
        <div className="custom_modal_body">
          <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
            <div className="row">
              {/* Date */}
              <div className="col-12">
                <DatePicker
                  key={`quotationDate`}
                  id="quotationDate"
                  label="Date"
                  labelHtmlFor="quotationDate"
                  required={true}
                  value={quotationDate}
                  placeholder="dd/mm/yyyy"
                  onChange={setQuotationDate}
                  error={quotationDateError}
                  showClear
                  onClear={() => setQuotationDate(null)}
                />
              </div>

              {/* Shop */}
              <div className="col-12">
                <div className="page_form_group">
                  <label htmlFor="shop" className="custom_form_label is_required">
                    Shop
                  </label>
                  <div className="input_with_button_area">
                    <InputText
                      id="shop"
                      value={selectedShop && selectedShop?.shop_name}
                      className="custom_form_input has_add_value text-capitalize"
                      placeholder="Click to select the shop."
                      readOnly={true}
                      autoComplete="off"
                      onClick={handleAddShop}
                    />
                    <button
                      className="add_value_btn p-ripple"
                      onClick={handleAddShop}
                    >
                      {selectedShop === null ? (
                        <React.Fragment>
                          <i className="bi bi-plus-lg"></i>
                          <span>Add</span>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <i className="bi bi-pencil-square"></i>
                          <span>Change</span>
                        </React.Fragment>
                      )}
                      <Ripple />
                    </button>
                  </div>

                  {quotationShopError && (
                    <small className="form_error_msg">
                      {quotationShopError}
                    </small>
                  )}
                </div>
              </div>

              {/* Title */}
              <div className="col-12">
                <TextInput
                  key={`quotationTitle`}
                  id="quotationTitle"
                  label="Title"
                  labelHtmlFor="quotationTitle"
                  required={true}
                  value={quotationTitle}
                  placeholder="Enter title"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setQuotationTitle(e.target.value)}
                  error={quotationTitleError}
                />
              </div>

              {/* Amount */}
              <div className="col-12">
                <NumberInput
                  key={`quotationAmount`}
                  inputId="quotationAmount"
                  label="Amount"
                  labelHtmlFor="quotationAmount"
                  placeholder="Enter amount"
                  onChange={handleQuotationAmountChange}
                  value={quotationAmount}
                  required={true}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  min={1}
                  prefix={currencySymbol + " "}
                  error={quotationAmountError}
                />
              </div>

              {/* File */}
              <div className="col-12">
                <FileInput
                  key={`quotationFile`}
                  id="quotationFile"
                  label="Upload file"
                  labelHtmlFor="quotationFile"
                  required={false}
                  value={quotationFileName}
                  canUploadImage={true}
                  onUpload={handleQuotationFileUpload}
                  onClear={handleClearQuotationFile}
                  toast={toast}
                  error={quotationFileError}
                  containerClassName="mb-2"
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Shops modal */}
      <Dialog
        visible={showShopsModal}
        headerClassName="d-none"
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm data_select_modal"
        contentClassName="data_select_modal_content"
        onHide={handleCloseShopsModal}
      >
        <div className="custom_modal_body data_select_modal_area">
          <div className="data_select_modal_header">
            <div className="data_search_input_area">
              <InputText
                key={"shopSearchKey"}
                id="shopSearchKey"
                value={shopSearchKey}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setShopSearchKey(e.target.value)}
                className="custom_form_input data_search_input"
                placeholder="Search shop by name"
                autoComplete="off"
                autoFocus
                type={"search"}
              />
              {shopSearchKey === "" ? (
                <i className="bi bi-search"></i>
              ) : (
                <i
                  className="bi bi-x-lg data_search_input_clear"
                  onClick={() => setShopSearchKey("")}
                ></i>
              )}
            </div>

            <button
              type="button"
              className="data_select_modal_close p-ripple"
              onClick={handleCloseShopsModal}
            >
              <i className="bi bi-x"></i>
              <Ripple />
            </button>
          </div>

          <div className="data_select_modal_body has_custom_input">
            {filteredShopsData && filteredShopsData?.length > 0 ? (
              <div className="data_select_option_area">
                {filteredShopsData?.map((shop) => (
                  <div
                    key={shop?.id}
                    className={`data_select_option p-ripple ${shop?.id === selectedShop?.id ? "selected" : ""}`}
                    onClick={() => handleSelectShop(shop)}
                  >
                    {shop?.shop_name}
                    <Ripple
                      pt={{ root: { tyle: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                  </div>
                ))}
              </div>
            ) : (
              <div className="no_records_found">
                <i className="bi bi-exclamation-circle me-1"></i>
                No data found.
              </div>
            )}
          </div>

          <div className="page_form_group data_select_modal_footer mb-0">
            <div className="input_with_button_area">
              <InputText
                key={`customShopName`}
                id="customShopName"
                value={customShopName}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomShopName(e.target.value)}
                className="custom_form_input has_add_value custom_data_input"
                placeholder="Enter shop name"
                autoComplete="off"
              />
              <button
                className="add_value_btn fill p-ripple"
                onClick={handleCreateCustomShop}
                disabled={customCreateLoading || customShopName === ""}
              >
                {customCreateLoading ? (
                  <span>Processing</span>
                ) : (
                  <React.Fragment>
                    <i className="bi bi-plus-lg"></i>
                    <span>Add</span>
                  </React.Fragment>
                )}
                <Ripple />
              </button>
            </div>
            {customShopNameError && (
              <small className="form_error_msg">{customShopNameError}</small>
            )}
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Document view modal */}
      <DocumentViewModal
        isOpen={showDocViewModal}
        onClose={handleCloseDocViewModal}
        fileUrl={documentFileUrl}
      />
    </React.Fragment>
  );
};

export default ProjectSpendingQuotation;
